import styled from 'styled-components';
import { px } from '../../../../../../contrib/ui';

export const DialogActionsStyled = styled.div`
  padding: auto ${px(10)};

  .dialog-actions {
    display: flex;

    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    width: 100%;
    height: ${px(50)};

    button {
      color: var(--mainColor);
      margin-right: ${px(10)};
    }
  }
`;
